import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

const FieldShell = ({ label, required, children, span = 1 }) => (
  <div className={span === 2 ? 'md:col-span-2' : ''}>
    <Label className="text-xs font-semibold uppercase tracking-wide text-slate-500">
      {label}{required ? ' *' : ''}
    </Label>
    <div className="mt-1.5">{children}</div>
  </div>
);

export default function CoreFieldForm({ fields, values, onChange }) {
  const setValue = (name, value) => {
    onChange({ ...values, [name]: value });
  };

  return (
    <div className="grid gap-4 md:grid-cols-2">
      {fields.map((field) => {
        const value = values[field.name] ?? '';

        if (field.type === 'textarea') {
          return (
            <FieldShell key={field.name} label={field.label} required={field.required} span={2}>
              <Textarea
                value={value}
                rows={field.rows || 4}
                placeholder={field.placeholder}
                onChange={(event) => setValue(field.name, event.target.value)}
              />
            </FieldShell>
          );
        }

        if (field.type === 'select') {
          return (
            <FieldShell key={field.name} label={field.label} required={field.required}>
              <select
                value={value}
                onChange={(event) => setValue(field.name, event.target.value)}
                className="h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              >
                <option value="">Not set</option>
                {(field.options || []).map((option) => {
                  const optionValue = typeof option === 'string' ? option : option.value;
                  const optionLabel = typeof option === 'string' ? option : option.label;
                  return <option key={optionValue} value={optionValue}>{optionLabel}</option>;
                })}
              </select>
            </FieldShell>
          );
        }

        return (
          <FieldShell key={field.name} label={field.label} required={field.required}>
            <Input
              type={field.type || 'text'}
              step={field.step}
              value={value}
              placeholder={field.placeholder}
              onChange={(event) => setValue(field.name, event.target.value)}
              list={field.listId}
            />
          </FieldShell>
        );
      })}
    </div>
  );
}
